import { CUSTOM_FIELD_TYPES } from "@/types/customFieldTypes";

const TYPE_STYLE_MAP: Record<string, { labelClass: string; valueClass: string }> = {
  [CUSTOM_FIELD_TYPES.Boolean]: {
    labelClass: 'data-type-badge-label-boolean',
    valueClass: 'data-type-badge-value-boolean',
  },
  [CUSTOM_FIELD_TYPES.Integer]: {
    labelClass: 'data-type-badge-label-integer',
    valueClass: 'data-type-badge-value-integer',
  },
  [CUSTOM_FIELD_TYPES.Float]: {
    labelClass: 'data-type-badge-label-float',
    valueClass: 'data-type-badge-value-float',
  },
  [CUSTOM_FIELD_TYPES.String]: {
    labelClass: 'data-type-badge-label-text',
    valueClass: 'data-type-badge-value-text',
  },
};

export function DataTypeBadge(props: { title: string; value: string; type: CUSTOM_FIELD_TYPES }) {
  const { title, value, type } = props;
  const styles = TYPE_STYLE_MAP[type] || TYPE_STYLE_MAP[CUSTOM_FIELD_TYPES.String];

  return (
    <span className="data-type-badge">
      <span className={`data-type-badge-label ${styles.labelClass}`}>{title}</span>
      <span className={`data-type-badge-value ${styles.valueClass}`}>{value || 'NULL'}</span>
    </span>
  );
}